// extracted by mini-css-extract-plugin
export default {"option-badge":"OptionBadge_option-badge__LJB1r","selected-option-badge":"OptionBadge_selected-option-badge__pASkh OptionBadge_option-badge__LJB1r"};